module.exports = __webpack_public_path__ + "img/title-milestones.6d5739d0.png";